import { Link } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React, { useEffect, useRef, useState, type FC } from 'react';
import { useTranslation } from 'react-i18next';
import DefaultImage from '../../../../../static/default-cover-image.jpg';
import { formatDateWithi18n } from '../../../../helpers/Formater';
import { formatSlug } from '../../../../utils/utils';
import type { CustomSlideProps } from './types';

const CustomSlide: FC<CustomSlideProps> = ({ item: { node } }) => {
    const imageData = getImage(node.slide_image?.CloudinaryImageFromStrapi);
    const { t } = useTranslation();

    const imageContainer = useRef(null);
    const [element, setElement] = useState(null);

    useEffect(() => {
        const mainImage = imageContainer.current.querySelector('[data-main-image]');
        setElement(mainImage);

        return () => {
            /**
             * gatsby-plugin-image has an issue with lazy-hydrate when the
             * componente delete before the gatsby-plugin-image try to remove
             * listener, it return error, becayse we removed the listener in the
             * componentWillUnmount method.
             */
            if (element) {
                element.removeEventListener('load');
            }
        };
    }, []);

    return (
        <div className="group transition-all duration-300 relative hover:shadow-gray-200 hover:shadow-md text-inherit">
            <Link to={`/${formatSlug(node.slug, node.locale)}`}>
                <div className="relative overflow-hidden justify-center content-center" ref={imageContainer}>
                    {node.slide_image?.CloudinaryImageFromStrapi ? (
                        <GatsbyImage
                            image={imageData}
                            alt={node.title}
                            loading={'eager'}
                            className={'w-full h-64 transition-all duration-500 group-hover:scale-125'}
                        />
                    ) : (
                        <img src={DefaultImage} alt={node.title} />
                    )}
                </div>
                <p className="h-24 p-5 bg-white text-black font-light text-lg">
                    <span className="line-clamp-2">{node.title}</span>
                </p>
                <div
                    className={`-20 p-5 text-sliceInfoText text-sm bg-sliceInfo
                        border-solid border-gray-200 border-t-2 text-center capitalize`}
                >
                    <b>{formatDateWithi18n({ value: node.publishedAt })}</b>
                    {` ${node.authors.length ? t('general.by', 'by') : ''} `}
                    {node.authors.map((author) => ` ${author.first_name} ${author.last_name}`)}
                </div>
            </Link>
        </div>
    );
};

export default CustomSlide;
